export class Layout {

  isFixed = true;
  isCollapsed = false;
  isBoxed = false;
  isRTL = false;
  horizontal = false;
  isFloat = false;
  asideHover = false;
  theme: string | undefined;
  tips = true;
  asideScrollbar = false;
  isCollapsedText = false;
  useFullLayout = false;
  hiddenFooter = false;
  offsidebarOpen = false;
  asideToggled = false;
  viewAnimation = 'ng-fadeInUp';
  titlePage = '';
  hideList: string[] = [];

}
